import './index.scss';

import React from 'react';
import { connect } from 'react-redux';

@connect((store) => {
  return {
    workstreams: store.workstreams,
    settings: store.settings,
  };
})
class ContactSupport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: null,
    };
  }

  render() {
    const { settings } = this.props;
    return (
      <div
        class="modal fade bg-overlay support-modal"
        data-backdrop="static"
        data-keyboard="false"
        id="contactSupportModal"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bb">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                  <p class="modalTitle">Contact Support</p>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2">
                  <a
                    class="text-right text-black"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="material-icons text-black text-size22">close</i>
                  </a>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="contactSupportContent">
                <p>
                  Submit a ticket through our{' '}
                  <a
                    href="https://www.notion.so/cloudcfoph/278db69b4c2d8030b354f2ef567de446?pvs=106"
                    target="_blank"
                  >
                    Helpdesk
                  </a>
                  <br />
                  or
                  <br />
                  Email us at support@cloudcfo.ph
                </p>

                <p class="app-version">App Version: {settings.app_version}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactSupport;
